//@ts-nocheck
import React from "react";
import styles from "./EditAction.module.scss";

function EditAction(props) {
	const { handleChange, value, actionProp, color, allowed } = props;

	function renderOptions() {
		const html = [];
		for (let i = 0; i < allowed.length; i++) {
			const action = allowed[i];
			const option = <option value={action}>{action}</option>;
			html.push(option);
		}

		const noneOption = <option value="">None</option>;

		html.push(noneOption);
		return html;
	}

	return (
		<div className={styles.inputWrapper} style={{ borderBottom: `1px dotted ${color.border.secondary}` }}>
			<label style={{ color: color.text.secondary }} className={styles.header} htmlFor={`edit_action_${actionProp}`}>
				Select Action Type:
			</label>
			<select name={actionProp} id={`edit_action_${actionProp}`} className={styles.select_input} onChange={handleChange} value={value}>
				{renderOptions()}
			</select>
		</div>
	);
}

export default EditAction;
